/* eslint-disable camelcase */
import { AmplitudeInteractionChannel } from 'Models/Amplitude/InteractionChannels';
import { AMPLITUDE_PROVIDER, BRAZE_PROVIDER } from '../providers';
import { AnalyticsManager } from '../AnalyticsManager';

export interface CommonEventData {
  interaction_channel: AmplitudeInteractionChannel;
  // eslint-disable-next-line @typescript-eslint/ban-types
  origin_screen: 'home_page' | string & {};
  kueski_user_id: string | undefined;
  user_type: 'rejected' | 'opportunity' | 'customer' | 'visitor' | 'indeterminate';
  app_source: 'kcash' | 'kpay';
}

export interface HomeEvents {
  'button_tapped': CommonEventData & { // TODO: create a dedicated event for each button_name
    button_name: 'direct_debit_banner_card'
      | 'home_help_center_button'
      | 'near_by_merchants_option'
      | 'download_app'
      | 'pop_up_high_risk_rejected_blog'
      | 'retargeting_application';
    // for retargeting_application button_name
    status?: string;
    type?: string;
  };
  'search_bar_tapped': CommonEventData & {
    string_searched: string;
  };
  'start_session': {
    interaction_channel: AmplitudeInteractionChannel;
  };
  'kueskipay_intent_started': CommonEventData & {
    origin_tab: 'sidebar' | 'carrousel';
  };
  'cash_intent_started': CommonEventData;
  'activity_section_tapped': CommonEventData & {
    origin_tab: 'SideBarMenu' | 'Main Carrousel';
  };
  'home_visited': CommonEventData & {
    origin_screen: string | null;
  };
  'profile_section_tapped': CommonEventData;
  'user_logged_out': CommonEventData;
  'credit_capacity_tapped': CommonEventData;
  'find_products_promos_banner_tapped': CommonEventData;
  'explore_section_tapped': CommonEventData;
}

const amplitudeProvider = new AnalyticsManager().addProvider(AMPLITUDE_PROVIDER);
const brazeProvider = new AnalyticsManager().addProvider(BRAZE_PROVIDER);

export function trackEvent<E extends keyof HomeEvents>(
  event: E,
  data: HomeEvents[E],
  platform: 'amplitude' | 'braze' = 'amplitude',
) {
  const provider = platform === 'amplitude' ? amplitudeProvider : brazeProvider;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return provider.sendEvent(event, data as any);
}
